import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button, Col, FormGroup, Input, Label, Row } from 'reactstrap';
class Login extends Component {
	render() {
		return (
			<>
				<div className='container-fluid pt-3'>
					<div className='d-flex align-items-center'>
						<h1 className='font-weight-bold text-uppercase'>
							Registration
						</h1>
					</div>
					<hr />
					<div
						className={`mt-5 ${
							!this.state.isEmail ? 'd-none' : ''
						}`}
					>
						<h5 className='font-weight-bold'>Log In to Memora</h5>
						<Row>
							<Col>
								<Input className='custom-form-control mt-4'></Input>
								<Button
									className='btn-outline w-100 mr-5 mt-3 dashboard-btn'
									onClick={e =>
										this.setState({ isEmail: false })
									}
								>
									Continue with email
								</Button>
							</Col>
						</Row>
						<div className='mt-5 pt-3'>
							<h4>or</h4>
							<Row>
								<Col>
									<Button className='w-100 btn-outline mr-5 mt-5 google-btn'>
										<i className='fa fa-google mr-2 '></i>
										Continue with google
									</Button>
								</Col>
								<Col xl='4'>
									<Button className='w-100 btn-outline facebook-btn mr-5 mt-5'>
										<i className='fa fa-facebook-f mr-2 '></i>
										Continue with facebook
									</Button>
								</Col>
								<Col xl='4'>
									<Button className='w-100 btn-outline mr-5 mt-5'>
										<i className='fa fa-apple mr-2'></i>
										Continue with apple
									</Button>
								</Col>
							</Row>
						</div>
						<h4 className='mt-5 mb-4'>Don't have account?</h4>
						<Button
							onClick={e =>
								this.props.history.push('/dashboard/signup')
							}
							className='btn-outline mr-5 mt-3 dashboard-btn'
						>
							Sign up
						</Button>
					</div>
					<div
						className={`mt-5 ${this.state.isEmail ? 'd-none' : ''}`}
					>
						<h5 className='font-weight-bold'>Welcome!</h5>
						<p className='m-0'>hello@world.com</p>
						<Row>
							<Col lg='6' xl='4'>
								<Input
									type='password'
									className='custom-form-control mt-4'
								></Input>
								<div className='d-flex align-items-center mt-2'>
									<FormGroup check>
										<Label check>
											<Input
												type='checkbox'
												name='checkbox'
											/>{' '}
											Keep me log In
										</Label>
									</FormGroup>
									<Link
										to='/dashboard/forget-password'
										className='ml-auto text-decoration-underline'
										style={{
											fontSize: 14,
											textDecoration: 'underline',
										}}
									>
										Forgot Password?
									</Link>
								</div>
								<Button className='btn-outline mr-5 mt-4 dashboard-btn'>
									Log in
								</Button>
							</Col>
						</Row>
					</div>
				</div>
			</>
		);
	}
}

export default Login;
